import { render, staticRenderFns } from "./Deactivate2FA.vue?vue&type=template&id=46374857&scoped=true&"
import script from "./Deactivate2FA.vue?vue&type=script&lang=js&"
export * from "./Deactivate2FA.vue?vue&type=script&lang=js&"
import style0 from "./Deactivate2FA.vue?vue&type=style&index=0&id=46374857&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46374857",
  null
  
)

export default component.exports